function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_20059",
  "data-name": "Path 20059",
  d: "M7009.4,2672.111l-2.022,11.17a.677.677,0,0,1-.665.554h-8.874a1.1,1.1,0,0,0-1.1,1.071.945.945,0,0,0,.917.973h.025l10.426.048a.605.605,0,0,0,.6-.5l1.958-11.56a.228.228,0,0,1,.449-.031l.455,1.464a.837.837,0,0,1,.027.379l-1.857,11.421a.834.834,0,0,1-.824.7h-13.165a2.141,2.141,0,0,1-2.1-2.573l2.52-12.279a3.055,3.055,0,0,1,2.993-2.441h10.186a.3.3,0,0,1,.3.3.319.319,0,0,1-.005.057Z",
  transform: "translate(-6993.602 -2670.504)"
});

var SvgLearnAbel = function SvgLearnAbel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 17.292,
    viewBox: "0 0 18 17.292",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLearnAbel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Learn_ABEL.2492ce00.svg";
export { ForwardRef as ReactComponent };